import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ApiValidationError } from 'contracts/Common';

const { Types, Creators } = createActions(
  {
    request: ['id', 'putData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage', 'validationErrors'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'UPDATE_ORDER_CANCELATION_REASON_',
  }
);

export type ReservedSlotAction = 'keepBlocked' | 'unlock';

export interface UpdateOrderCancelationReasonPayload {
  cancelationReasonId: number;
  reservedSlotAction: ReservedSlotAction;
}

export interface UpdateOrderCancelationReasonState {
  id: number | null;
  loading: boolean;
  errorMessage: string | null;
  validationErrors: ApiValidationError[];
}

export interface UpdateOrderCancelationReasonRequestAction {
  id: number;
  putData: UpdateOrderCancelationReasonPayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface FailureAction {
  errorMessage: string;
  validationErrors?: ApiValidationError[];
}

const INITIAL_STATE: UpdateOrderCancelationReasonState = {
  id: null,
  loading: false,
  errorMessage: null,
  validationErrors: [],
};

const request = (
  state: UpdateOrderCancelationReasonState,
  action: UpdateOrderCancelationReasonRequestAction
) =>
  update(state, {
    id: { $set: action.id },
    loading: { $set: true },
    errorMessage: { $set: null },
    validationErrors: { $set: [] },
  });

const success = (state: UpdateOrderCancelationReasonState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const failure = (
  state: UpdateOrderCancelationReasonState,
  action: FailureAction
) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
    validationErrors: { $set: action.validationErrors || [] },
  });

const softReset = (state: UpdateOrderCancelationReasonState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const updateOrderCancelationReason = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const UpdateOrderCancelationReasonTypes = Types;
export const UpdateOrderCancelationReasonActions = Creators;
